var search4i = function(){
	var panel,
	searchTxtBox,
	searchStatus,
	searchButton,
	autoCompleteWrap,
	typingTimer,
	doneTypingInterval = 200, //0.2 sec	
	minCharacters = 2,
	keys = { ESC: 27, TAB: 9, RETURN: 13, DOWN: 40, CAPS: 20 };
	
	/*var supportsPassive = false;
	try {
  		var opts = Object.defineProperty({}, 'passive', {
    			get: function() {
      				supportsPassive = true;
    			}
  		});
  		window.addEventListener("testPassive", null, opts);
  		window.removeEventListener("testPassive", null, opts);
	} catch (e) {}*/
	
	var init = function(){
		panel = document.getElementById("SuggestionPanel");
		searchTxtBox = document.getElementById("txtSearch");
		searchStatus = document.getElementById("searchStatus");
		searchButton = document.getElementById("submitSearch");
		autoCompleteWrap = document.getElementById("autoCompWrapper");
		
		searchTxtBox.addEventListener("keyup", function(e){	
			if(e.keyCode == keys.DOWN && autoCompleteWrap.querySelector("a")){
				// only instance of down arrow use - to skip tabbing to the search button
				autoCompleteWrap.querySelector("a").focus();
			}else if(e.keyCode == keys.RETURN) {
				ajaxActions.Search(searchTxtBox.value);
			}else if ((e.keyCode < 35 || e.keyCode > 40) && e.keyCode !== keys.ESC && e.keyCode !== keys.CAPS) {
				// extreme key code stuff needed to get this to play nice with voiceover/safari
				autoComplete.Close();
				searchSuggestion.Close();
				if(document.getElementById("searchError")) document.getElementById("searchError").remove();

				clearTimeout(typingTimer);
	    			if (searchTxtBox.value.length > minCharacters) {
	        			typingTimer = setTimeout(autoComplete.Get, doneTypingInterval);
	   			}
	   		}
		});
		searchButton.addEventListener("click", function(e){
			e.preventDefault();
			ajaxActions.Search(searchTxtBox.value);
		}); 	
		
		document.addEventListener("keyup", function(e){
			if(e.keyCode == keys.ESC){
				if(!panel.classList.contains("hide")){
					e.preventDefault();
					e.stopPropagation();
					searchSuggestion.Close();
					searchTxtBox.focus();
				}
				if(autoCompleteWrap.getAttribute("aria-hidden") == "false"){
					e.preventDefault();
					e.stopPropagation();
					autoComplete.Close();
					searchTxtBox.focus();
				}
			}
		});
	},
	
	autoComplete = (function(){
		var updateStatus = function(listLength){
			if (listLength === 0 || searchTxtBox.value === "" || searchTxtBox.value === "Search"){
				searchStatus.innerHTML = 'No autocomplete suggestions available';
			} else{ 
				searchStatus.innerHTML = listLength + ' Autocomplete suggestions are available for '+ searchTxtBox.value + ', use your down arrow key to access these suggestions then your tab key to navigate the results.'; 
			}
		},
		create = function(term, searchList){
			term = term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // term searched for in input field
			var re = new RegExp("(" + term.split(' ').join('|') + ")", "gi");
			var autoHtml = "<ul class='acSuggestionList bkgdWhite borderDkGray text16 reset resetList animate animateFadeIn animateFaster'>";
			for(var i = 0; i < searchList.length; i++){			
				autoHtml += 
					"<li class='acSuggestion padding5 displayFlex flexNoWrap flexSpaceBetween flexAlignItemsCenter'>" +
						"<a href='#' class='acSearch noLine darkestLink textLeft padding5' data-val='" + searchList[i].SearchTerm + "'>" +
							"<span>" + searchList[i].SearchTerm.replace(re, '<span class="textSemiBold">$1</span>') + "</span> <span class='searchResultNo'>(" + searchList[i].ResultCount + "<span class='visually-hidden'> products</span>)</span>" +
						"</a>" +
						"<button class='pointer darkestLink padding5' aria-expanded='false' aria-label='View top search results for " + searchList[i].SearchTerm + "'><svg class='rotate90 show' height='20px' width='20px' focusable='false'><title>View top search results for " + searchList[i].SearchTerm + "</title><use xlink:href='#svgIcon-arrowLine'></use> </svg></button>" +
					"</li>";
			}
			autoHtml += "</ul>";			
			return autoHtml;
		},
		close = function(){
			if(document.querySelector(".acSuggestionList")){
				document.querySelector(".acSuggestionList").parentNode.removeChild(document.querySelector(".acSuggestionList"));
			}
			if(document.getElementById("searchLoading")){
				document.getElementById("searchLoading").parentNode.removeChild(document.getElementById("searchLoading"));
			}
			//searchTxtBox.setAttribute("aria-expanded", "false");
			autoCompleteWrap.setAttribute("aria-hidden", "true");
			searchStatus.innerHTML = ""; 
			panel.innerHTML = "";
			document.removeEventListener('click', detectOutsideClick);
		},
		get = function(){
			//searchTxtBox.setAttribute("aria-expanded", "true");
			autoCompleteWrap.setAttribute("aria-hidden", "false");
			autoCompleteWrap.insertAdjacentHTML("afterbegin", "<div id='searchLoading' class='spinner bkgdWhite borderDkGray paddingTop5 paddingBtm5' role='alert' aria-busy='true' aria-atomic='true' aria-label='Loading search autocomplete list, please wait'><div class='bounce1'></div><div class='bounce2'></div><div class='bounce3'></div></div>");
			ajaxActions.GetAutoComplete(searchTxtBox.value);
		},
		removeSelectedRow = function(row){
			row.classList.remove("selected");
			row.querySelector("svg").setAttribute("class", "rotate90 show");
			row.querySelector("button").setAttribute("aria-expanded", "false");
		},
		showHide = function(e){
			var el = e.currentTarget;
			if(el.getAttribute("aria-expanded") == "false"){
				if(document.querySelector(".acSuggestionList").querySelector(".selected")){
					removeSelectedRow(document.querySelector(".acSuggestionList").querySelector(".selected"));
				}
				searchSuggestion.Open(el.parentNode);
			}else{
				searchSuggestion.Close();
			}
		},
		detectOutsideClick = function(e){
			if(!panel.contains(e.target) && !autoCompleteWrap.contains(e.target)){
				if(!panel.classList.contains("hide")){
					searchSuggestion.Close();
				}
				if(autoCompleteWrap.getAttribute("aria-hidden") == "false"){
					autoComplete.Close();
				}
				searchTxtBox.focus();
			}
		},
		events = function(){ 
			var acItems = [].slice.call(document.querySelectorAll(".acSuggestion"));
			var lastSuggestionBtn = acItems[acItems.length - 1].querySelector("button");
			
			acItems.forEach(function(acItem){				
				acItem.addEventListener("mouseenter", function(e){
					e.preventDefault();
					searchSuggestion.Open(acItem);
				});				
				/*acItem.querySelector("button").addEventListener("touchstart", showHide, supportsPassive ? { passive: true } : false);
				acItem.querySelector("button").addEventListener("keydown", function(e){	
					if(e.keyCode == keys.RETURN){
						e.preventDefault();
						e.stopPropagation();
						showHide(e);
					}
				});*/
				acItem.querySelector("button").removeEventListener("click", carrotClick);
				acItem.querySelector("button").addEventListener("click", carrotClick);
				
				acItem.querySelector("button").removeEventListener("keydown", carrotKey);
				acItem.querySelector("button").addEventListener("keydown", carrotKey);
			});
			lastSuggestionBtn.addEventListener("keydown", function(e){
				if(e.keyCode == keys.TAB){
					e.preventDefault();
					e.stopPropagation();
					acItems[0].querySelector("a").focus();
				}
			});
			var acItemLinks = [].slice.call(document.querySelectorAll(".acSearch"));
			acItemLinks.forEach(function(acItemLink){
				acItemLink.addEventListener("click", function(e){
					e.preventDefault();
	            			ajaxActions.Search(acItemLink.getAttribute("data-val"));
				});
			});
			
			document.removeEventListener('click', detectOutsideClick); // may not be needed
			document.addEventListener('click', detectOutsideClick);
		},
		carrotClick = function(e){
			e.preventDefault();
			showHide(e);
		},
		carrotKey = function(e){// space or enter
			// per a11y manual testing, this is needed
			if(e.which == 32 || e.which == 13){ 
				e.preventDefault();
				showHide(e);
			}
		};
		return{
			UpdateStatus: updateStatus,
			Create: create,
			Close: close,
			Get: get,
			RemoveSelectedRow: removeSelectedRow,
			Events: events
		};
	})(),
	
	searchSuggestion = (function(){
		var open = function(row){
			if(autoCompleteWrap.querySelector(".selected")){
				autoComplete.RemoveSelectedRow(autoCompleteWrap.querySelector(".selected"));
			}
			row.classList.add("selected");
			row.querySelector("svg").setAttribute("class", "rotate270 show");
			panel.innerHTML = "<div class='spinner paddingTop10 paddingBtm10' role='alert' aria-busy='true' aria-atomic='true' aria-label='Loading top search suggestions, please wait'><div class='bounce1'></div><div class='bounce2'></div><div class='bounce3'></div></div>"; 
			panel.classList.remove("hide");
			panel.setAttribute("aria-hidden", "false");
				
			var searchTerm = row.querySelector(".acSearch").getAttribute("data-val");
			ajaxActions.GetSuggestionPanel(row, searchTerm);
		},
		close = function(e){
			if(e){ e.preventDefault(); }
			if(autoCompleteWrap.querySelector(".selected")){
				var selectedRow = autoCompleteWrap.querySelector(".selected");
				selectedRow.querySelector("button").removeEventListener("click", close);
				selectedRow.querySelector("button").focus();
				autoComplete.RemoveSelectedRow(selectedRow);	
			}
			panel.classList.add("hide");
			panel.setAttribute("aria-hidden", "true");
		},
		keyEvents = function(e){
			if(document.getElementById("SearchSuggestionPanelViewAll")){
				if(e.keyCode == keys.TAB && document.getElementById("SearchSuggestionPanelViewAll") == document.activeElement) {
					e.preventDefault();
					e.stopPropagation();
					panel.querySelector("button").focus();
				}
			}else{
				// error or no items found
				if(e.keyCode == keys.TAB && document.getElementById("closeSearchSuggestion") == document.activeElement) {
					e.preventDefault();
					e.stopPropagation();
					document.getElementById("closeSearchSuggestion").focus();
				}
			}
		},
		events = function(){
			panel.removeEventListener("keydown", keyEvents); 
			panel.addEventListener("keydown", keyEvents);
				
			document.getElementById("closeSearchSuggestion").removeEventListener("click", close);
			document.getElementById("closeSearchSuggestion").addEventListener("click", close);
			
			var closeArrowBtn = autoCompleteWrap.querySelector(".selected").querySelector("button");
			closeArrowBtn.addEventListener("click", close);
		},
		errorHTML = function(errorText){
			var returnHTML = '<div id="SearchSection" class="padding5 animate animateFadeIn animateFaster">' +
        					'<div class="displayFlex flexNoWrap flexSpaceBetween bkgdWhite marginBtm10">' +
            						'<p class="text16 padding10" role="alert" aria-atomic="true">' + errorText + '</p>' +
            						'<button id="closeSearchSuggestion" class="darkestLink btnToHyp padding10">' +
                						'<svg class="show" height="20px" width="20px" aria-label="Close Search Suggestion Dialog" focusable="false"> <use xlink:href="#svgIcon-close"></use> </svg>' +
           				 		'</button>' +
        					'</div>' +
    					'</div>';
    			return returnHTML;
		};
		
		return{
			Events: events,
			Close: close,
			Open: open,
			ErrorHTML: errorHTML
		};
	})(),
	
	ajaxActions = (function(){
		var autoCompleteAbort = new AbortController(),
		searchSuggestAbort = new AbortController(),
		
		getAutoComplete = function(searchTerm){
			var searched = searchTerm.toLowerCase();
			autoCompleteAbort.abort(); // abort a request in progress
			autoCompleteAbort = new AbortController(); // reset so the upcoming request can be cancelled
						
			fetch('/Header/SearchAutoComplete', { 
				method: 'POST', 
				body: JSON.stringify({ searchTerm: searched }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' },
				signal: autoCompleteAbort.signal
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if(document.getElementById("searchLoading")){
					document.getElementById("searchLoading").parentNode.removeChild(document.getElementById("searchLoading"));
				}  		
				autoCompleteWrap.innerHTML = "";
				var searchList = autoComplete.Create(searched, response);
				autoCompleteWrap.innerHTML = searchList;
				autoComplete.UpdateStatus(response.length);
				autoComplete.Events();
			}).catch(function(e){ /* fires if the fetch is aborted. Empty to suppress console logging. */ });
		},
		getSuggestionPanel = function(itemExpanding, searchTerm){
			searchSuggestAbort.abort(); // abort a request in progress
			searchSuggestAbort = new AbortController();  // reset so the upcoming request can be cancelled
			fetch('/Header/SearchBoxSuggestions', { 
				method: 'POST', 
				body: JSON.stringify({ searchTerm: searchTerm }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' },
				signal: searchSuggestAbort.signal
			}).then(function(response){
				return  (response.ok) ? response.text() : ''; // response.text() returns a promise
			}).then(function(response){
				if(response.length){
					panel.innerHTML = response;
				}else{
					var noResults = 'We are sorry, there are no top search results for <span class="textSemiBold">' + searchTerm + '</span>';
					panel.innerHTML = searchSuggestion.ErrorHTML(noResults);
				}
				itemExpanding.querySelector("button").setAttribute("aria-expanded", "true");
				panel.querySelector("button").focus();
				searchSuggestion.Events();
			}).catch(function(e){ /* fires if the fetch is aborted. Empty to suppress console logging. */ });
		},
		search = function(searchText) {
			//don't search for nothing
			if(document.getElementById("searchError")) document.getElementById("searchError").remove();
			if(searchText !== ""){
				fetch('/Header/Search', { 
					method: 'POST', 
					body: JSON.stringify({ searchText: searchText }), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
				}).then(function(response){
					return  (response.ok) ? response.json() : {url: ''}; // response.text() returns a promise
				}).then(function(response){
					if(response.url !== '') window.location.href = response.url;
				});
			}else{
				var searchError = '<span id="searchError" class="text16 textDkRed" role="alert" aria-atomic="true">Error, please enter search content.</span>';
				document.getElementById("txtSearch").parentNode.insertAdjacentHTML("afterend", searchError);
			}
		};
		return{
			GetAutoComplete: getAutoComplete,
			GetSuggestionPanel: getSuggestionPanel,
			Search: search
		};
	})();
	
	return{
		Init: init
	};
};
(function(){
	var loadSearch = new search4i();
	loadSearch.Init();
})();